

import React from "react";
//import Button from "../common/Button";
import styles from "../css/LongFormContent.module.css";

function LongFormContent({ data }: any) {
  return (
    <section className={styles.longFormContent}>
      <h1 className={styles.headline}>{data.headline}</h1>
      {data.tableOfContents.isEnabled && (
        <nav className={styles.tableOfContents}>
          <h2>Table of Contents</h2>
          <ul>
            {data.tableOfContents.items.map((item: any, index: number) => (
              <li key={index}>
                <a href={`#${item.anchor}`}>{item.title}</a>
              </li>
            ))}
          </ul>
        </nav>
      )}
      {data.sections.map((section: any, index: number) => (
        <div key={index} className={styles.section} id={`section-${index}`}>
          <h2>{section.title}</h2>
          <div dangerouslySetInnerHTML={{ __html: section.content }} />
          {section.image && (
            <img 
              src={section.image.src} 
              alt={section.image.alt} 
              className={styles.sectionImage}
            />
          )}
        </div>
      ))}
      {data.faq && (
        <div className={styles.faq}>
          <h2>Frequently Asked Questions</h2>
          {data.faq.map((item: any, index: number) => (
            <div key={index} className={styles.faqItem}>
              <h3>{item.question}</h3>
              <p>{item.answer}</p>
            </div>
          ))}
        </div>
      )}
      {data.callouts.map((callout: any, index: number) => (
        <div 
          key={index} 
          className={styles.callout}
          style={{
            backgroundColor: callout.style.backgroundColor,
            color: callout.style.textColor,
            borderColor: callout.style.borderColor
          }}
        >
          <h3>{callout.title}</h3>
          <p>{callout.content}</p>
        </div>
      ))}
      <div className={styles.ctaContainer}>
        {/*<Button {...data.primaryCTA} />*/}
      </div>
    </section>
  );
};

export default LongFormContent;
